import { SVGProps } from "react";

const IconWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2063_26560)">
      <g clipPath="url(#clip1_2063_26560)">
        <path
          d="M11.3538 3.97409C11.7395 3.31128 12.6969 3.31128 13.0825 3.97409L21.8232 18.9971C22.2111 19.6638 21.7301 20.5 20.9588 20.5L3.47752 20.5C2.70623 20.5 2.2253 19.6638 2.61317 18.9971L11.3538 3.97409Z"
          fill="#FCEDC6"
          stroke="#DB900B"
          strokeWidth="2"
        />
        <path
          d="M12 7.25L12 13.25"
          stroke="#DB900B"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle
          cx="12"
          cy="16.625"
          r="1"
          stroke="#DB900B"
          strokeWidth="1.75"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2063_26560">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(24 24.5) rotate(180)"
        />
      </clipPath>
      <clipPath id="clip1_2063_26560">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(24 24.5) rotate(180)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IconWarning;
